import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const EMPTY_SIGNER = { signer_type: 'PARTICIPANT', representative_contact_id: '', signed_by_name: '' };

/** Batch 1A A5 — who signed: the participant, or a representative holding VERIFIED authority valid on the signing date. */
export function SignerSelector({ agreementId, value, onChange, signedOn }) {
  const [options, setOptions] = useState({ participant: { name: '' }, representatives: [] });
  useEffect(() => {
    if (!agreementId) return;
    api.get(`/agreements/${agreementId}/documents/signers`, { params: signedOn ? { on: signedOn } : {} })
      .then((r) => setOptions(r.data?.data || { participant: { name: '' }, representatives: [] }))
      .catch(() => setOptions({ participant: { name: '' }, representatives: [] }));
  }, [agreementId, signedOn]);

  const pick = (key) => {
    if (key === 'PARTICIPANT') onChange({ ...value, signer_type: 'PARTICIPANT', representative_contact_id: '', signed_by_name: value.signed_by_name || options.participant?.name || '' });
    else {
      const rep = options.representatives.find((r) => r.id === key);
      onChange({ ...value, signer_type: 'REPRESENTATIVE', representative_contact_id: key, signed_by_name: rep?.name || value.signed_by_name });
    }
  };
  const current = value.signer_type === 'REPRESENTATIVE' ? value.representative_contact_id : 'PARTICIPANT';
  return (
    <div className="space-y-2" data-testid="agreement-signer-selector">
      <div>
        <Label>Who signed *</Label>
        <Select value={current} onValueChange={pick}>
          <SelectTrigger data-testid="agreement-signer-type"><SelectValue placeholder="Select signer" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="PARTICIPANT" data-testid="agreement-signer-participant">Participant{options.participant?.name ? ` — ${options.participant.name}` : ''}</SelectItem>
            {options.representatives.map((r) => (
              <SelectItem key={r.id} value={r.id} data-testid={`agreement-signer-representative-${r.id}`}>{r.name} — {r.authority_type_label || r.authority_type || 'Representative'} (verified)</SelectItem>
            ))}
          </SelectContent>
        </Select>
        {options.representatives.length === 0 && <p className="text-[11px] text-muted-foreground mt-1" data-testid="agreement-signer-no-representatives">No representative with verified authority valid on the signing date — verify the authority on the participant contact first.</p>}
      </div>
      <div>
        <Label>Signed by name *</Label>
        <Input value={value.signed_by_name} onChange={(e) => onChange({ ...value, signed_by_name: e.target.value })} data-testid="agreement-sign-name" required />
      </div>
    </div>
  );
}
